module.exports = __webpack_public_path__ + "media/images/cms/img_slide_03-36f8ddd1aea393a4ee0bd2d911d43ef3.jpg";